const requiredFiles = require.context(
    './fa-IR',
    false,
);

const modules = {};

requiredFiles.keys().forEach(key => {
    const module = requiredFiles(key);
    const moduleName = key
        .split('/')
        .pop()
        .replace(/\.\w+$/, '');

    modules[moduleName] = module.default || module;
});

export default modules;
